export class NumberUtils {

	static formatNumberWithDecimals(number: number, fractionDigits: number = 2): string {
		const parts = number.toFixed(fractionDigits).split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		return parts.join(',');
	}

	static padZero(value: number, finalLength?: number): string {
		return `0${value}`.slice(finalLength);
	}
}
